//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SitesSessionStorageService } from "@nuskin/ns-util";
import { NsIcon } from "@nuskin/design-components";

import NsMinimalHeaderProfileToggle from "./NsMinimalHeaderProfileToggle.vue";

const PROFILE_CLOSED = "profileClosed";
export default {
  name: "NsMinimalHeaderProfileDropdown",
  components: {
    NsIcon,
    NsMinimalHeaderProfileToggle
  },
  props: {
    /**
     * List of potential navigation links
     */
    profileMenu: {
      type: Array,
      default: () => []
    },
    /**
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    /**
     * The url where signup link takes you
     */
    signUpUrl: {
      type: String,
      default: ""
    },
    /**
     * Translations for component
     * Required keys: id, greeting, newCustomerLabel,
     * signUpTodayLabel, signIn, signOut, signUp
     */
    translations: {
      type: Object,
      default: () => ({})
    },
    profileTranslations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dropdownOpen: !SitesSessionStorageService.getItem(PROFILE_CLOSED)
  }),
  methods: {
    handleCloseClick() {
      this.$emit("close-drawer");
    },
    handleDropdownToggle() {
      this.dropdownOpen = !this.dropdownOpen;
      SitesSessionStorageService.removeItem(PROFILE_CLOSED);
      SitesSessionStorageService.writeItem(PROFILE_CLOSED, !this.dropdownOpen);
    }
  }
};
